// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + (chunkId === 594 ? "about" : chunkId) + "." + {"481":"355838c6","594":"f183b501"}[chunkId] + ".css";
};